import React from 'react';
import styled from 'styled-components';
import HostMicMutedBadge from './HostMicMutedBadge';

export default function LiveHostStatus({ interrupted, cameraOff, micMuted }: {
  interrupted: boolean; cameraOff: boolean; micMuted: boolean;
}) {
  const status: { icon: HostStatusIconType; title: string; description?: string } | null = interrupted
    ? { icon: 'interrupted', title: '잠시만 기다려 주시면 곧 방송이 재개됩니다.',
        description: '셀러의 연결 상태로 인해 방송이 잠시 대기 중입니다.' }
    : cameraOff
      ? { icon: 'camera', title: '셀러가 잠시 카메라 화면을 가림 처리했습니다.',
          description: '곧 영상이 재개되니 조금만 기다려주세요.' }
      : null;

  return <>
    {(status || micMuted) && <Host_Status role="status" aria-live="polite">
      {status && <>
        {cameraOff && !interrupted
          ? <Host_Logo src={require('../../Image/Logo.png')} alt="팬버드" />
          : <Host_Status_Icon><HostStatusIcon type={status.icon} /></Host_Status_Icon>}
        <Host_Status_Title>{status.title}</Host_Status_Title>
        {status.description && <Host_Status_Description>{status.description}</Host_Status_Description>}
      </>}
      {!interrupted && micMuted && <HostMicMutedBadge />}
    </Host_Status>}
  </>;
}

const Host_Status = styled.div`
  position: absolute;
  z-index: 55;
  top: 36%;
  left: 20px;
  right: 20px;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #ffffff;
  text-align: center;
  word-break: keep-all;
  overflow-wrap: break-word;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.55);
  pointer-events: none;
`;

const Host_Status_Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-bottom: 12px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.42);
`;

const Host_Logo = styled.img`
  width: var(--space-12, 48px);
  height: var(--space-12, 48px);
  object-fit: contain;
  margin-bottom: var(--space-4, 16px);
`;

const Host_Status_Title = styled.div`
  font-family: var(--font-Pretendard-SemiBold);
  font-size: calc(14px * var(--studio-font-scale, 1));
  line-height: 1.45;
`;

const Host_Status_Description = styled.div`
  margin-top: 5px;
  color: rgba(255, 255, 255, 0.58);
  font-family: var(--font-Pretendard-Regular);
  font-size: calc(12px * var(--studio-font-scale, 1));
  line-height: 1.45;
`;

type HostStatusIconType = "interrupted" | "camera";

const HostStatusIcon: React.FC<{ type: HostStatusIconType }> = ({ type }) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {type === "interrupted" && (
      <>
        <path d="M5 12.55a11 11 0 0 1 14 0" />
        <path d="M8.5 16.1a6 6 0 0 1 7 0" />
        <path d="M12 20h.01" />
      </>
    )}
    {type === "camera" && (
      <>
        <path d="M15 7H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2Z" />
        <path d="m17 10 4-2v8l-4-2" />
      </>
    )}
    <path d="m3 3 18 18" />
  </svg>
);
